<project-tracker-project-comments
  #projectComments
  [activeUser]="activeUser$ | async"
  [conversation]="conversation$$ | async"
  [isLoading]="isLoading$$ | async"
  [disablePrivate]="true"
  [isSubmitting]="createCommentLoading$ | async"
  (closeClicked)="handleCloseClick()"
  (submitClicked)="handleSubmitClick($event)"
></project-tracker-project-comments>
